import { useQuery } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { QueryConfig } from '@/lib/react-query';
import { ProgramBroadcastFiltersState } from '@/stores/program-broadcast-filters';
import { ParamsWithPagination } from '@/types/api';

import { TClip } from '../types';

type TGetClips = {
  filters?: Partial<ProgramBroadcastFiltersState>;
  params?: ParamsWithPagination<unknown>;
};
export async function getClips({ filters, params }: TGetClips): Promise<TClip[]> {
  return mediaManagerClient
    .get('api/v1/clips', {
      params: {
        ...(params?.limit && { limit: params.limit }),
        ...(params?.offset && { offset: params.offset }),
        ...(filters?.search && { search: filters.search }),
        ...(filters?.gte && { start_datetime__gte: filters.gte }),
        ...(filters?.lte && { end_datetime__lte: filters.lte }),
        ...(filters?.channelType && {
          media_type__in: filters.channelType === 'tvts' ? 'tv' : 'r',
        }),
        ...(filters?.review_states &&
          filters.review_states.length > 0 && {
            review_states: filters.review_states.join(','),
          }),
        ...(filters?.time_keeping_states &&
          filters.time_keeping_states.length > 0 && {
            time_keeping_states: filters.time_keeping_states.join(','),
          }),
        ...(filters?.logos &&
          filters?.logos.length > 0 && { logo_id__in: filters.logos.join(',') }),
        ...(filters?.broadcasters &&
          filters?.broadcasters.length > 0 && {
            channel_id__in: filters.broadcasters.join(','),
          }),
        ...(filters?.programs &&
          filters?.programs.length > 0 && {
            program_id__in: filters.programs.join(','),
          }),
        ...(filters?.people &&
          filters?.people.length > 0 && {
            people_id__in: filters.people.join(','),
          }),
        ...(filters?.workspaces &&
          filters?.workspaces.length > 0 && {
            workspace_id__in: filters.workspaces.join(','),
          }),
        ...(filters?.projects &&
          filters?.projects.length > 0 && {
            project_id__in: filters.projects.join(','),
          }),
        ...(filters?.clients &&
          filters?.clients.length > 0 && {
            client_id__in: filters.clients.join(','),
          }),
        ...(filters?.tags &&
          filters?.tags.length > 0 && {
            tag_id__in: filters.tags.join(','),
          }),
        ...(filters?.programs &&
          filters?.programs.length > 0 && {
            program_id__in: filters.programs.join(','),
          }),
        ...(filters?.order_by && { order_by: filters.order_by }),
      },
    })
    .then(({ data }) => data);
}

type QueryFnType = typeof getClips;

interface UseFeaturedPeopleParams {
  config?: QueryConfig<QueryFnType>;
  filters?: Partial<ProgramBroadcastFiltersState>;
  params?: ParamsWithPagination<unknown>;
}

export function useGetClips({ config, filters, params }: UseFeaturedPeopleParams = {}) {
  return useQuery({
    ...config,
    queryKey: ['clips', filters, params],
    queryFn: () => getClips({ filters, params }),
  });
}
